(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("beqAh", function(module, exports) {

$parcel$export(module.exports, "readingTime", function () { return $82d59f8de4186dbf$export$e0705390d0a3a181; });
const $82d59f8de4186dbf$var$i = {
    less: "less than a minute read",
    default: "min read"
}, $82d59f8de4186dbf$var$o = {
    less: "moins d'une minute de lecture",
    default: "min de lecture"
}, $82d59f8de4186dbf$var$l = {
    less: "menos de un minuto leyendo",
    default: "min de lectura"
}, $82d59f8de4186dbf$var$d = {
    less: "\u5C0F\u4E8E\u4E00\u5206\u949F",
    default: "\u5206\u949F"
}, $82d59f8de4186dbf$var$r = {
    less: "1\u5206\u672A\u6E80\u306E\u8AAD\u307F\u53D6\u308A",
    default: "\u6700\u5C0F\u8AAD\u307F\u53D6\u308A"
}, $82d59f8de4186dbf$var$c = {
    less: "weniger als eine Minute Lesezeit",
    default: "Min. Lesezeit"
}, $82d59f8de4186dbf$var$m = {
    less: "menos de um minuto de leitura",
    default: "minutos de leitura"
}, $82d59f8de4186dbf$var$f = {
    less: "bir dakikadan az okuma s\xfcresi",
    default: "dakika okuma s\xfcresi"
}, $82d59f8de4186dbf$var$p = {
    less: "timp de citire mai pu\u021Bin de un minut",
    default: "min. timp de lectur\u0103"
}, $82d59f8de4186dbf$var$g = {
    less: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u0995\u09AE \u09B8\u09AE\u09AF\u09BC\u09C7 \u09AA\u09A1\u09BC\u09C1\u09A8",
    default: "\u09B8\u09B0\u09CD\u09AC\u09A8\u09BF\u09AE\u09CD\u09A8 \u09B8\u09AE\u09AF\u09BC\u09C7 \u09AA\u09A1\u09BC\u09C1\u09A8"
}, $82d59f8de4186dbf$var$k = {
    less: "menej ako min\xfata \u010D\xedtania",
    default: "min \u010D\xedtania"
}, $82d59f8de4186dbf$var$h = {
    less: "m\xe9n\u011B ne\u017E minuta \u010Dten\xed",
    default: "min \u010Dten\xed"
}, $82d59f8de4186dbf$var$b = {
    en: $82d59f8de4186dbf$var$i,
    fr: $82d59f8de4186dbf$var$o,
    es: $82d59f8de4186dbf$var$l,
    cn: $82d59f8de4186dbf$var$d,
    ja: $82d59f8de4186dbf$var$r,
    de: $82d59f8de4186dbf$var$c,
    "pt-br": $82d59f8de4186dbf$var$m,
    tr: $82d59f8de4186dbf$var$f,
    ro: $82d59f8de4186dbf$var$p,
    bn: $82d59f8de4186dbf$var$g,
    sk: $82d59f8de4186dbf$var$k,
    cs: $82d59f8de4186dbf$var$h
}, $82d59f8de4186dbf$export$1c2c8674a5fbafd = [
    "en",
    "fr",
    "es",
    "cn",
    "ja",
    "de",
    "pt-br",
    "tr",
    "ro",
    "bn",
    "sk",
    "cs"
], $82d59f8de4186dbf$var$L = (e)=>(e.match(/[\w|\d|\s|,|.|\u00C0-\u024F|\u4E00-\u9FA5|\u3041-\u309F]+/giu) ?? []).flatMap((s)=>s.match(/[\u4E00-\u9FA5]/gu) ?? s), $82d59f8de4186dbf$var$M = (e)=>$82d59f8de4186dbf$var$L(e).reduce((t, s)=>t + (s.trim().length ? s.trim().split(/\s+/u).length : 0), 0), $82d59f8de4186dbf$var$F = (e)=>e < 1 + Number.EPSILON, $82d59f8de4186dbf$var$j = (e, t = "en")=>$82d59f8de4186dbf$var$b[t][e ? "less" : "default"], $82d59f8de4186dbf$export$e0705390d0a3a181 = (e, t = 300, s = "en")=>{
    const u = $82d59f8de4186dbf$var$M(e), n = Math.round(u / t), a = $82d59f8de4186dbf$var$F(n);
    return {
        minutes: n,
        words: u,
        text: `${a ? "" : `${n} `}${$82d59f8de4186dbf$var$j(a, s)}`
    };
};

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    const hamburgerBtn = document.querySelector(".btn.btn-hamburger");
    const closeBtn = document.querySelector(".btn.navigationDrawer--closeBtn");
    const topNav = document.querySelector(".top-navigation");
    const drawer = document.querySelector(".navigationDrawer");
    // Open drawer → hide top nav, show drawer
    hamburgerBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.add("d-none");
        if (drawer) drawer.classList.remove("d-none");
    });
    // Close drawer → show top nav, hide drawer
    closeBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.remove("d-none");
        if (drawer) drawer.classList.add("d-none");
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("c1Wog"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("GPAku"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("fKF0o"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "staflexx.html",
                logoSrc: new URL((parcelRequire("2vrmN"))),
                title: "Staflexx"
            },
            {
                pageUrl: "trakn.html",
                logoSrc: new URL((parcelRequire("1MIUa"))),
                title: "Trakn"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("dsHBJ"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("c1Wog", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "battery-charging.ba1b1745.webp";

});

parcelRegister("GPAku", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "settings-02.d69d69bd.webp";

});

parcelRegister("fKF0o", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "life-buoy.285e728c.webp";

});

parcelRegister("2vrmN", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "Staflexx_favicon.0afb56d6.webp";

});

parcelRegister("1MIUa", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "trakn_favicon.ffb5470c.webp";

});

parcelRegister("dsHBJ", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("7NWNe") + "box.2a34708a.webp";

});


parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $12a9dd7254655733$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("7NWNe"), JSON.parse('["7NWNe","blog-detail.e0e3f1c2.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","dHV0l","Staflexx_favicon.0afb56d6.webp","cmPFA","trakn_favicon.ffb5470c.webp","9Glg9","box.2a34708a.webp"]'));


var $beqAh = parcelRequire("beqAh");
parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("2SvjK");
// Arrow Up Icon Button
const $37cd39c312d81570$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".btn.contents__blog--cardReadMoreBtn").forEach((el)=>{
    el.innerHTML += $37cd39c312d81570$var$arrowUpIcon;
});
document.querySelectorAll(".btn.otherPost__blogDetail--cardReadMoreBtn").forEach((el)=>{
    el.innerHTML += $37cd39c312d81570$var$arrowUpIcon;
});
const $37cd39c312d81570$var$viewAllBtn = document.querySelector(".btn.otherPost__blogDetail--viewAllBtn");
if ($37cd39c312d81570$var$viewAllBtn) $37cd39c312d81570$var$viewAllBtn.innerHTML += $37cd39c312d81570$var$arrowUpIcon;
const $37cd39c312d81570$var$bookDemoBtn = document.querySelector(".btn.btn-book-demo");
if ($37cd39c312d81570$var$bookDemoBtn) $37cd39c312d81570$var$bookDemoBtn.innerHTML += $37cd39c312d81570$var$arrowUpIcon;
const $37cd39c312d81570$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $37cd39c312d81570$var$chevronDownIcon;
});
const $37cd39c312d81570$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
const $37cd39c312d81570$var$hamburgerBtn = document.querySelector(".btn-hamburger");
if ($37cd39c312d81570$var$hamburgerBtn) $37cd39c312d81570$var$hamburgerBtn.innerHTML += $37cd39c312d81570$var$hamburgerIcon;
// Environment Variable Setup
let $37cd39c312d81570$var$rawStrapiUrl = "https://blogger.wenodo.com/";
$37cd39c312d81570$var$rawStrapiUrl = $37cd39c312d81570$var$rawStrapiUrl.replace(/\/+$/, "");
if ($37cd39c312d81570$var$rawStrapiUrl.endsWith("/api")) $37cd39c312d81570$var$rawStrapiUrl = $37cd39c312d81570$var$rawStrapiUrl.slice(0, -4);
const $37cd39c312d81570$var$STRAPI_URL = $37cd39c312d81570$var$rawStrapiUrl;
const $37cd39c312d81570$var$STRAPI_TOKEN = "3f50eea6cbec44e0476f34e97fff30090c4988b28db1788b6da675c93a027a09e8fd7ca8d27b453b09cdc6cb8fd1984bd7e5060cbb74508685c5159ce970c013ab43ae323b2b50681b3639734275574d44feb62a7b6f6b33467172ad56c23a74e166659691c859efc0d2a8134969cd47ff95960967e435534e4cc97205d2b397";
const $37cd39c312d81570$var$BASE_URL = "https://wenodo.com/";
function $37cd39c312d81570$var$resolveRichText(nodes) {
    if (typeof nodes === "string") return nodes;
    if (!Array.isArray(nodes)) return "";
    return nodes.map((c)=>$37cd39c312d81570$var$resolveRichTextNode(c)).join("");
}
function $37cd39c312d81570$var$resolveRichTextNode(node) {
    if (!node) return "";
    let html = "";
    const children = Array.isArray(node.children) ? node.children.map((c)=>$37cd39c312d81570$var$resolveRichTextNode(c)).join("") : "";
    switch(node.type){
        case "heading":
            html = `<h${node.level || 1}>${children}</h${node.level || 1}>`;
            break;
        case "text":
            if (node.text) {
                let tmp = node.text.replaceAll("\n", "<br />");
                if (node.bold) tmp = `<b>${tmp}</b>`;
                if (node.code) tmp = `<code>${tmp}</code>`;
                if (node.italic) tmp = `<i>${tmp}</i>`;
                if (node.strikethrough) tmp = `<s>${tmp}</s>`;
                if (node.underline) tmp = `<u>${tmp}</u>`;
                html = tmp;
            }
            break;
        case "paragraph":
            html = `<p>${children}</p>`;
            break;
        case "link":
            html = `<a href="${node.url || "#"}">${children}</a>`;
            break;
        case "list":
            switch(node.format){
                case "ordered":
                    html = `<ol>${children}</ol>`;
                    break;
                case "unordered":
                default:
                    html = `<ul>${children}</ul>`;
                    break;
            }
            break;
        case "list-item":
            html = `<li>${children}</li>`;
            break;
        case "quote":
            html = `<blockquote>${children}</blockquote>`;
            break;
        case "code":
            html = `<pre>${children}</pre>`;
            break;
        case "image":
            if (node.image?.url) html = `<img src="${node.image.url}" height="${node.image.height || ""}" width="${node.image.width || ""}" alt="${node.image.alternativeText || ""}" />`;
            break;
    }
    return html;
}
function $37cd39c312d81570$var$formatTitleSlug(title) {
    if (!title) return "";
    return title.replaceAll(":", "").replaceAll(" ", "-");
}
function $37cd39c312d81570$var$getCoverUrl(coverData) {
    if (typeof coverData === "string") return coverData;
    const url = coverData?.data?.attributes?.url || coverData?.url;
    if (!url) return "";
    return url.replace("/upload", "/upload/q_auto:eco").replace(".png", ".webp");
}
// Get Data Strapi
const $37cd39c312d81570$var$myHeaders = new Headers();
if ($37cd39c312d81570$var$STRAPI_TOKEN) $37cd39c312d81570$var$myHeaders.append("Authorization", `Bearer ${$37cd39c312d81570$var$STRAPI_TOKEN}`);
const $37cd39c312d81570$var$requestOptions = {
    method: "GET",
    headers: $37cd39c312d81570$var$myHeaders,
    redirect: "follow"
};
function $37cd39c312d81570$var$getBlogSlug(data, id) {
    if (data?.slug) return data.slug;
    const title = data?.Title || data?.title;
    if (title) return title.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
    return id || "";
}
function $37cd39c312d81570$var$getBlogIdentifier() {
    const url = new URL(window.location.href);
    // 1. Check path after /blog-detail.html/ or /blog-detail/
    const pathname = url.pathname.replace(/\/+$/, "");
    const pathParts = pathname.split("/");
    const blogDetailIndex = pathParts.findIndex((p)=>p === "blog-detail.html" || p === "blog-detail");
    if (blogDetailIndex !== -1 && pathParts[blogDetailIndex + 1]) {
        let slugInPath = decodeURIComponent(pathParts.slice(blogDetailIndex + 1).join("/"));
        if (slugInPath) {
            slugInPath = slugInPath.replace(/\.html$/i, "");
            if (slugInPath) return slugInPath;
        }
    }
    // 2. Check query parameter: blogId, id, slug
    const blogId = url.searchParams.get("blogId") || url.searchParams.get("id");
    if (blogId) return blogId;
    const slugParam = url.searchParams.get("slug");
    if (slugParam) return slugParam;
    // 3. Check query string key (e.g. ?welcoming-noreen-london-to-the-wenodo-family)
    const ignoredParams = new Set([
        "category",
        "page",
        "blogid",
        "id",
        "slug",
        "fbclid",
        "gclid",
        "ref",
        "source"
    ]);
    const keys = Array.from(url.searchParams.keys());
    for (const k of keys){
        if (k && !ignoredParams.has(k.toLowerCase()) && !k.toLowerCase().startsWith("utm_")) return k;
    }
    // 4. Raw search fallback if search is ?slug-string
    const rawSearch = window.location.search;
    if (rawSearch && rawSearch.startsWith("?")) {
        const rawContent = decodeURIComponent(rawSearch.slice(1).split("&")[0]);
        if (rawContent && !rawContent.includes("=")) return rawContent;
    }
    return null;
}
function $37cd39c312d81570$var$cleanText(text) {
    if (!text) return "";
    return text.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}
function $37cd39c312d81570$var$setMetaTag(nameOrProperty, content) {
    if (content === undefined || content === null) return;
    const cleanContent = String(content).trim();
    const isProperty = nameOrProperty.startsWith("og:") || nameOrProperty.startsWith("article:");
    const targetLower = nameOrProperty.toLowerCase();
    const allMetas = Array.from(document.querySelectorAll("meta"));
    const matched = allMetas.filter((m)=>{
        const n = (m.getAttribute("name") || "").toLowerCase();
        const p = (m.getAttribute("property") || "").toLowerCase();
        return n === targetLower || p === targetLower;
    });
    if (matched.length > 0) matched.forEach((m)=>m.setAttribute("content", cleanContent));
    else {
        const meta = document.createElement("meta");
        meta.setAttribute(isProperty ? "property" : "name", nameOrProperty);
        meta.setAttribute("content", cleanContent);
        document.head.appendChild(meta);
    }
}
function $37cd39c312d81570$var$setCanonicalTag(url) {
    if (!url) return;
    let link = document.getElementById("seo-canonical") || document.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", url);
}
function $37cd39c312d81570$var$updateSeoMetadata(dataObj, slug) {
    if (!dataObj) return;
    const rawTitle = dataObj.Title || dataObj.title || "";
    const rawMetaTitle = dataObj.metaTitle || dataObj.meta_title || dataObj.seo?.metaTitle || rawTitle || "Blog Detail";
    let rawMetaDesc = dataObj.metaDescription || dataObj.meta_description || dataObj.seo?.metaDescription || dataObj.summary || dataObj.ogDescription || dataObj.Detail || dataObj.detail || "";
    if (!rawMetaDesc && dataObj.contents) {
        const text = typeof dataObj.contents === "string" ? dataObj.contents : $37cd39c312d81570$var$resolveRichText(dataObj.contents);
        rawMetaDesc = $37cd39c312d81570$var$cleanText(text).slice(0, 160);
    }
    if (!rawMetaDesc && dataObj.content) rawMetaDesc = $37cd39c312d81570$var$cleanText(dataObj.content).slice(0, 160);
    const cleanDesc = $37cd39c312d81570$var$cleanText(rawMetaDesc);
    const cleanMetaTitle = $37cd39c312d81570$var$cleanText(rawMetaTitle);
    const finalTitle = cleanMetaTitle.toLowerCase().includes("wenodo") ? cleanMetaTitle : `${cleanMetaTitle} | Wenodo`;
    // 1. Title Tag (both document.title and <title> DOM element)
    document.title = finalTitle;
    const titleTag = document.getElementById("seo-title") || document.querySelector("title");
    if (titleTag) titleTag.textContent = finalTitle;
    // 2. Meta Description (update name="description", og:description, twitter:description)
    if (cleanDesc) $37cd39c312d81570$var$setMetaTag("description", cleanDesc);
    // 3. Keywords
    const keywords = dataObj.keywords || dataObj.seo?.keywords || "";
    if (keywords) $37cd39c312d81570$var$setMetaTag("keywords", $37cd39c312d81570$var$cleanText(keywords));
    // 4. Robots
    const isNoIndex = dataObj.noIndex || dataObj.noindex || false;
    $37cd39c312d81570$var$setMetaTag("robots", isNoIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    // 5. Canonical URL
    const siteUrl = "https://www.wenodo.com";
    const postUrl = dataObj.canonicalUrl || dataObj.canonical_url || dataObj.seo?.canonicalUrl || (slug ? `${siteUrl}/blog-detail/${slug}` : `${siteUrl}/blog-detail`);
    $37cd39c312d81570$var$setCanonicalTag(postUrl);
    // 6. Cover & OG Image
    const cover = dataObj.cover || dataObj.coverImage || dataObj.ogImage || "";
    const coverUrl = $37cd39c312d81570$var$getCoverUrl(cover);
    const ogImageUrl = dataObj.ogImage || coverUrl;
    // 7. Open Graph Tags
    const ogTitle = $37cd39c312d81570$var$cleanText(dataObj.ogTitle || dataObj.og_title || cleanMetaTitle || rawTitle);
    const ogDescription = $37cd39c312d81570$var$cleanText(dataObj.ogDescription || dataObj.og_description || cleanDesc);
    const finalOgTitle = ogTitle ? ogTitle.toLowerCase().includes("wenodo") ? ogTitle : `${ogTitle} | Wenodo` : finalTitle;
    $37cd39c312d81570$var$setMetaTag("og:title", finalOgTitle);
    $37cd39c312d81570$var$setMetaTag("og:description", ogDescription || cleanDesc);
    $37cd39c312d81570$var$setMetaTag("og:url", postUrl);
    $37cd39c312d81570$var$setMetaTag("og:type", "article");
    $37cd39c312d81570$var$setMetaTag("og:site_name", "Wenodo");
    if (ogImageUrl) $37cd39c312d81570$var$setMetaTag("og:image", ogImageUrl);
    const publishedAt = dataObj.publishedAt || dataObj.createdAt || "";
    if (publishedAt) $37cd39c312d81570$var$setMetaTag("article:published_time", publishedAt);
    const updatedAt = dataObj.updatedAt || dataObj.updated_at || publishedAt || "";
    if (updatedAt) $37cd39c312d81570$var$setMetaTag("article:modified_time", updatedAt);
    const author = dataObj.author || "Wenodo Team";
    $37cd39c312d81570$var$setMetaTag("article:author", author);
    // 8. Twitter Tags
    $37cd39c312d81570$var$setMetaTag("twitter:card", "summary_large_image");
    $37cd39c312d81570$var$setMetaTag("twitter:title", finalOgTitle);
    $37cd39c312d81570$var$setMetaTag("twitter:description", ogDescription || cleanDesc);
    if (ogImageUrl) $37cd39c312d81570$var$setMetaTag("twitter:image", ogImageUrl);
    // 9. JSON-LD Article Schema
    let schemaScript = document.getElementById("blog-article-jsonld");
    if (!schemaScript) {
        schemaScript = document.createElement("script");
        schemaScript.id = "blog-article-jsonld";
        schemaScript.type = "application/ld+json";
        document.head.appendChild(schemaScript);
    }
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: cleanMetaTitle || rawTitle,
        description: cleanDesc,
        ...ogImageUrl ? {
            image: [
                ogImageUrl
            ]
        } : {},
        ...publishedAt ? {
            datePublished: publishedAt
        } : {},
        ...updatedAt ? {
            dateModified: updatedAt
        } : {},
        author: {
            "@type": "Organization",
            name: author,
            url: "https://www.wenodo.com"
        },
        publisher: {
            "@type": "Organization",
            name: "Wenodo",
            logo: {
                "@type": "ImageObject",
                url: "https://www.wenodo.com/assets/image/app-logo.png"
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": postUrl
        }
    };
    schemaScript.textContent = JSON.stringify(schemaData, null, 2);
}
function $37cd39c312d81570$var$slugify(text) {
    if (!text) return "";
    return text.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function $37cd39c312d81570$var$renderBlogDetail(dataObj, identifier) {
    if (!dataObj) return;
    const activeSlug = $37cd39c312d81570$var$getBlogSlug(dataObj, identifier);
    // 1. Update complete SEO metadata FIRST so title, meta description, and tags are set immediately
    try {
        $37cd39c312d81570$var$updateSeoMetadata(dataObj, activeSlug || identifier);
    } catch (err) {
        console.error("Error updating SEO metadata:", err);
    }
    const Title = dataObj.Title || dataObj.title || "";
    const publishedAt = dataObj.publishedAt || dataObj.createdAt || "";
    const cover = dataObj.cover || dataObj.coverImage || dataObj.ogImage || "";
    const contents = dataObj.contents || dataObj.content || dataObj.Detail || dataObj.summary || "";
    const titleEl = document.querySelector('[data-element="title-blog"]');
    if (titleEl) titleEl.innerHTML = Title;
    const readingTimeEl = document.querySelector('[data-element="readingTime"]');
    if (readingTimeEl && contents) {
        const textContent = typeof contents === "string" ? contents : $37cd39c312d81570$var$resolveRichText(contents);
        readingTimeEl.innerHTML = (0, $beqAh.readingTime)(textContent, 300).text;
    }
    const publishedAtEl = document.querySelector('[data-element="publishedAt"]');
    if (publishedAtEl && publishedAt) {
        if (typeof moment !== "undefined") publishedAtEl.innerHTML = moment(publishedAt).format("MMM. DD, Y");
        else try {
            publishedAtEl.innerHTML = new Date(publishedAt).toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric"
            });
        } catch (e) {
            publishedAtEl.innerHTML = publishedAt;
        }
    }
    const coverImgEl = document.querySelector('[data-element="coverImage"]');
    const coverUrl = $37cd39c312d81570$var$getCoverUrl(cover);
    if (coverImgEl) {
        if (coverUrl) {
            coverImgEl.src = coverUrl;
            coverImgEl.style.display = "block";
        } else coverImgEl.style.display = "none";
    }
    const sepEl = document.querySelector('[data-element="time-separator"]');
    if (sepEl && publishedAt) sepEl.style.display = "inline";
    const contentBlogEl = document.querySelector('[data-element="contentBlog"]');
    if (contentBlogEl && contents) contentBlogEl.innerHTML = $37cd39c312d81570$var$resolveRichText(contents);
    if (activeSlug) {
        const expectedPath = `${$37cd39c312d81570$var$BASE_URL}/blog-detail/${activeSlug}`;
        if (window.location.pathname !== expectedPath || window.location.search || window.location.pathname.includes(".html")) window.history.replaceState(null, "", expectedPath);
    }
    const innerEl = document.querySelector(".contents__blogDetail--inner");
    if (innerEl) innerEl.style.display = "flex";
}
async function $37cd39c312d81570$var$loadBlog(identifier) {
    try {
        // 1. Try direct fetch by identifier (slug or id)
        const directRes = await fetch(`${$37cd39c312d81570$var$STRAPI_URL}/api/blogs/${encodeURIComponent(identifier)}`, $37cd39c312d81570$var$requestOptions);
        if (directRes.ok) {
            const result = await directRes.json();
            const dataObj = result?.data?.attributes || result?.data;
            if (dataObj) {
                $37cd39c312d81570$var$renderBlogDetail(dataObj, result.data?.id || identifier);
                return;
            }
        }
        // 2. Fallback: Search all blogs by matching slug / title slug / prefix
        const listRes = await fetch(`${$37cd39c312d81570$var$STRAPI_URL}/api/blogs?page=1&pageSize=100`, $37cd39c312d81570$var$requestOptions);
        if (listRes.ok) {
            const listResult = await listRes.json();
            const blogs = listResult?.data || [];
            const normIdentifier = $37cd39c312d81570$var$slugify(identifier);
            const matched = blogs.find((b)=>{
                const data = b?.attributes || b;
                const bSlug = $37cd39c312d81570$var$slugify(data.slug);
                const bTitleSlug = $37cd39c312d81570$var$slugify(data.Title || data.title);
                return b.id === identifier || bSlug && bSlug === normIdentifier || bTitleSlug && bTitleSlug === normIdentifier || bSlug && normIdentifier.startsWith(bSlug) || bSlug && bSlug.startsWith(normIdentifier) || bTitleSlug && normIdentifier.startsWith(bTitleSlug) || bTitleSlug && bTitleSlug.startsWith(normIdentifier);
            });
            if (matched) {
                const detailRes = await fetch(`${$37cd39c312d81570$var$STRAPI_URL}/api/blogs/${encodeURIComponent(matched.id)}`, $37cd39c312d81570$var$requestOptions);
                if (detailRes.ok) {
                    const detailResult = await detailRes.json();
                    const dataObj = detailResult?.data?.attributes || detailResult?.data;
                    if (dataObj) {
                        $37cd39c312d81570$var$renderBlogDetail(dataObj, detailResult.data?.id || matched.id);
                        return;
                    }
                }
            }
        }
        // 3. If not found at all, show friendly not found message
        const titleEl = document.querySelector('[data-element="title-blog"]');
        if (titleEl) titleEl.innerHTML = "Blog Post Not Found";
        const contentBlogEl = document.querySelector('[data-element="contentBlog"]');
        if (contentBlogEl) contentBlogEl.innerHTML = '<p>The requested blog post could not be found. Please check our <a href="/blog">Blog page</a> for the latest articles.</p>';
        document.title = "Blog Post Not Found | Wenodo";
        const innerEl = document.querySelector(".contents__blogDetail--inner");
        if (innerEl) innerEl.style.display = "flex";
    } catch (error) {
        console.error("Error loading blog detail:", error);
    }
}
const $37cd39c312d81570$var$identifier = $37cd39c312d81570$var$getBlogIdentifier();
if ($37cd39c312d81570$var$identifier) $37cd39c312d81570$var$loadBlog($37cd39c312d81570$var$identifier);
const $37cd39c312d81570$var$gridListBlogs = (datas)=>{
    if (!Array.isArray(datas)) return;
    const gridBlogs = document.querySelector(".otherPost__blogDetail--cards");
    if (!gridBlogs) return;
    const _datas = datas.slice(1, 4);
    _datas.forEach((_data)=>{
        const data = _data?.attributes || _data;
        if (!data) return;
        const templateCard = gridBlogs.querySelector('[data-element="blog-card"]');
        if (!templateCard) return;
        const cardElement = templateCard.cloneNode(true);
        cardElement.style.display = "flex";
        const slug = $37cd39c312d81570$var$getBlogSlug(data, _data.id);
        const detailUrl = `${$37cd39c312d81570$var$BASE_URL}/blog-detail/${slug}`;
        const urlLinkImg = cardElement.querySelector('[data-element="url-link-image"]');
        if (urlLinkImg) {
            urlLinkImg.setAttribute("href", detailUrl);
            const img = urlLinkImg.querySelector("img");
            if (img) img.src = $37cd39c312d81570$var$getCoverUrl(data.cover || data.coverImage || data.ogImage);
        }
        const createdDate = cardElement.querySelector('[data-element="created-date"]');
        const pubDate = data.publishedAt || data.createdAt;
        if (createdDate && pubDate) {
            if (typeof moment !== "undefined") createdDate.innerHTML = moment(pubDate).format("MMM. DD, Y");
            else try {
                createdDate.innerHTML = new Date(pubDate).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric"
                });
            } catch (e) {
                createdDate.innerHTML = pubDate;
            }
        }
        const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]');
        const contents = data.contents || data.content || data.Detail || data.summary;
        if (readingTimeEl && contents) {
            const textContent = typeof contents === "string" ? contents : $37cd39c312d81570$var$resolveRichText(contents);
            readingTimeEl.innerHTML = (0, $beqAh.readingTime)(textContent, 300).text;
        }
        const titleEl = cardElement.querySelector('[data-element="title"]');
        if (titleEl) titleEl.innerHTML = data.Title || data.title || "";
        const descEl = cardElement.querySelector('[data-element="description"]');
        if (descEl) descEl.innerHTML = data.Detail || data.summary || "";
        const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]');
        if (readMoreLink) readMoreLink.setAttribute("href", detailUrl);
        gridBlogs.appendChild(cardElement);
    });
    const cards = gridBlogs.querySelectorAll('[data-element="blog-card"]');
    if (cards.length > 0) cards[0].remove();
};
fetch(`${$37cd39c312d81570$var$STRAPI_URL}/api/blogs?page=1&pageSize=4`, $37cd39c312d81570$var$requestOptions).then((response)=>{
    if (!response.ok) return null;
    return response.json();
}).then((result)=>{
    if (result?.data) $37cd39c312d81570$var$gridListBlogs(result.data);
    const otherInnerEl = document.querySelector(".otherPost__blogDetail--inner");
    if (otherInnerEl) otherInnerEl.style.display = "flex";
}).catch((error)=>console.error(error));

})();
//# sourceMappingURL=blog-detail.e0e3f1c2.js.map
